import api from "./api";

const RESOURCE = "/api/regional";

const Regional = {
  listData: async (id) => await api.get(RESOURCE + `/pessoa/${id}`),
  sendData: async (data) => await api.post(RESOURCE, { ...data }),
  editingData: async (id, data) =>
    await api.put(RESOURCE + `/${id}`, { ...data }),
  searchRegionais: async (data) =>
    await api.get(RESOURCE + `/buscar?cnpjOuNome=${data || ""}`),
};

export default Regional;
